import React from "react";
import PropTypes from "prop-types";

import { Control, Input, Label } from "rbx";

import { debounce } from "../utils";

const DateInput = ({
  id,
  value,
  name,
  label,
  size,
  onChange,
  onBlur,
  disabled,
  getValue,
  setValue,
  required,
  showLabel,
  debounceThreshold
}) => {
  const handleChange = debounce(e => {
    onChange(e.target.name, setValue(e.target.value));
  }, debounceThreshold);

  const handleBlur = e => {
    onBlur(e.target.name, e.target.value);
  };

  return (
    <Control expanded>
      {showLabel && <Label>{label}</Label>}
      <Input
        defaultValue={getValue(value)}
        disabled={disabled}
        id={id}
        key={getValue(value)}
        name={name}
        required={required}
        size={size}
        type="date"
        onBlur={handleBlur}
        onChange={e => {
          e.persist();
          return handleChange(e);
        }}
      />
    </Control>
  );
};

DateInput.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.number
  ]),
  name: PropTypes.string,
  label: PropTypes.string,
  size: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  getValue: PropTypes.func,
  setValue: PropTypes.func,
  onBlur: PropTypes.func,
  id: PropTypes.string,
  required: PropTypes.bool,
  showLabel: PropTypes.bool,
  debounceThreshold: PropTypes.number
};

DateInput.defaultProps = {
  value: "",
  name: "",
  label: "Date",
  size: "small",
  onChange: () => null,
  onBlur: () => {},
  disabled: false,
  getValue: x => x,
  setValue: x => x,
  id: "",
  required: false,
  showLabel: true,
  debounceThreshold: 1000
};

export default DateInput;
